import { Btn, H6, LI, Progressbar, UL } from '../../../../AbstractElements'
import { FaDatabase } from 'react-icons/fa'
import { Storage } from '../../../../utils/Constant'

const StoragePlan = () => {
  return (
    <UL className='simple-list'>
      <LI>
        <Btn outline color="primary" block className='progress-text text-start'>
          <FaDatabase />
          {Storage}
        </Btn>
        <div className="m-t-15">
          <Progressbar color="primary" style={{ height: "8px" }} value={30} className="mb-3"/>
          <H6 className="f-w-700">{"25 GB of 100 GB used"}</H6>
        </div>
      </LI>
    </UL>
  )
}

export default StoragePlan